import { useUserStore } from '@/stores/userStore';

/**
 * Convenience hook to get the current user's auth token.
 * Avoids threading token through every component manually.
 *
 * The store carries falsy sentinels (null/false) for a logged-out session;
 * we normalize those to undefined.
 */
export function useToken(): string | undefined {
  const token = useUserStore(state => state.user?.token);
  return token || undefined;
}

export default useToken;
